import AccessHealthSupportSrc from "../assets/img/card-images/Access-Health-Support_1112-x-646.jpg";
import AccessHealthSupportSrcMobile from "../assets/img/card-images/Access-Health-Support_580x340.jpg";
import AccessHealthSupportHolSrc from "../assets/img/hol/hol-hspromo-580x400.png";
import { Paths } from "../constants/UrlConstants";

const PromoCards = {
  AccessHealthSupportSrc: {
    IconSrc: {
      Any: AccessHealthSupportSrc,
      HOL: AccessHealthSupportHolSrc
    },
    IconSrcMobile: {
      Any: AccessHealthSupportSrcMobile,
      HOL: AccessHealthSupportHolSrc
    },
    Heading: {
      Any : "Access health support",
      HOL : "Access health hub",
    },
    Description: {
      Any:
        "We are here to support you with your health, every step of the way. Explore how we can help you and your family.",
      HOL:
        "We are here to support you with your health, every step of the way. Explore how we can help you and your family."
    },
    LinkText: {
      Any: "Health support",
      HOL: "Health Hub",
    },
    LinkTo: Paths.HealthSupport,
    LinkToHOL: Paths.HealthHub,
    ExternalLinkTo: null
  }
};

export default PromoCards;
